import { createSelector } from 'reselect';

// Dynamic Menu
export const getMenuList = (state) => state.menu.menuList;
export const getIsLoadingMenuList = (state) => state.menu.isLoading;
export const getSelectedMenuSlug = (state) => state.menu.selectedMenuSlug;

// Generic copies
export const getCopiesList = (state) => state.copies.copiesList;
export const getIsLoadingCopiesList = (state) => state.copies.isLoading;

// Dynamic pages that belongs to dynamic menu
export const getPageList = (state) => state.pages.pageList;
export const getIsLoadingPagesList = (state) => state.pages.isLoading;

// Events
export const getEventsList = (state) => state.events.eventsList;
export const getIsLoadingEventsList = (state) => state.events.isLoading;
export const getEventsFilter = (state) => state.events.events;

// Lawyers
export const getLawyersList = (state) => state.lawyers.lawyersList;
export const getLawyersFilter = (state) => state.lawyers.selectedStateToFilter;

// States
export const getStatesList = (state) => state.states.statesList;

// Menu selectors
export const isLoadingMenueSeector = createSelector(
  getIsLoadingMenuList,
  (isLoading) => isLoading
);
export const menuListSelector = createSelector(
  getMenuList,
  (menuList) => menuList
);

// Copies selector
export const copyListSelector = createSelector(
  getCopiesList,
  (copiesList) => copiesList
);

// Dynamic pages selectors
export const isLoadingPagesSeector = createSelector(
  getIsLoadingPagesList,
  (isLoading) => isLoading
);

export const pagesListSelector = createSelector(
  [getPageList, getSelectedMenuSlug],
  (pageList, selectedMenuSlug) =>
    pageList.filter((page) => page.menu?.slug === selectedMenuSlug)
);

export const pageListSelector = createSelector(
  getPageList,
  (pageList) => pageList
);

// Events selectors
export const eventsListSelector = createSelector(
  [getEventsList, getEventsFilter],
  (eventsList, eventsFilter) =>
    eventsList.filter(
      (event) => eventsFilter === '' || event.state === eventsFilter
    )
);

// Lawyers selectors
export const lawyersListSelector = createSelector(
  [getLawyersList, getLawyersFilter],
  (lawyersList, lawyersFilter) =>
    lawyersList.filter(
      (lawyer) => lawyersFilter === '' || lawyer.state === lawyersFilter
    )
);

export const lawyersFilterSelector = createSelector(
  getLawyersFilter,
  (lawyersFilter) => lawyersFilter
);

// States selectors
export const statesListSelector = createSelector(
  getStatesList,
  (statesList) => statesList
);
